export enum IconStatus {
    Loading,
    GenericError,
}
